import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star-filled--sprite",
  "use": "star-filled--sprite-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"star-filled--sprite\">\n<path d=\"M6.99992 10.8465L11.1199 13.3332L10.0266 8.6465L13.6666 5.49317L8.87325 5.0865L6.99992 0.666504L5.12659 5.0865L0.333252 5.49317L3.97325 8.6465L2.87992 13.3332L6.99992 10.8465Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol